<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <h1 class="text-h3 mb-4">Welcome to Home</h1>
        <v-btn color="primary" to="/order">
          Go to Order Page
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'HomePage'
}
</script>

<script setup>
</script> 